import { datadogRum } from '@datadog/browser-rum';

const PAGE_VIEW_ID_KEY = 'ncTracking.pageViewId';

export const getPageViewId = (): number => Number(sessionStorage.getItem(PAGE_VIEW_ID_KEY) || 0);

export const setPageViewId = (id: number): void => sessionStorage.setItem(PAGE_VIEW_ID_KEY, String(id));

type BeaconErrorT = {
  failureMessage: string;
  context?: Record<string, unknown>;
};

export const sendBeacon = (
  url: string,
  body: unknown,
  { context, failureMessage }: BeaconErrorT,
): void => {
  const blob = new Blob([JSON.stringify(body)], { type: 'application/json' });
  const queued = navigator.sendBeacon(url, blob);

  if (!queued) {
    datadogRum.addError(new Error(failureMessage), { url, ...context });
  }
};
